import React from 'react'
import {
	ColorsSchemeNames,
	Container,
	convertColor,
	opacityBackgroundCss,
	Shimmer,
	themedBorderRadius,
} from '@rst/ui-ts'
import { media } from '@rst/libs-ts'
import styled from 'styled-components'
import { blockHeights } from './lib'
import { CardPreloader } from '../../render-block/card-block/preloader'
import { LeadFormWrapper, SimplesBlocksType } from '../../render-block'
import { LeadFormPreloader } from '../../render-block/lead-form-half/preloader'
import { LeadFormVerticalPreloader } from '../../render-block/lead-form/preloader/lead-form-vertical'
import { LeadFormModPreloader } from '../../render-block/lead-form/preloader/lead-form-mod'
import { LeadFormHorizontalHalfPreloader } from '../../render-block/lead-form/preloader/lead-form-horizontal-half'
import { LeadFormContactPreloader } from '../../render-block/lead-form/preloader/lead-form-contact'

type BlockPreloadProps = {
	id?: string
	type?: string
	bgImage?: string
	bgColor?: ColorsSchemeNames
	titleAs?: string
	x?: SimplesBlocksType.AllBlock & any
}

export const BlockPreload = ({
	id,
	type,
	bgColor,
	bgImage,
	titleAs,
	x,
}: BlockPreloadProps) => {
	if (type === 'rst-poll')
		return (
			<PreloaderNone id={id} type={type} bgColor={bgColor} bgImage={bgImage} />
		)
	if (type === 'card-block')
		return (
			<CardPreloader
				data={x as SimplesBlocksType.Blocks.CardBlock}
				titleAs={titleAs}
			/>
		)
	if (type === 'lead-form' || type === 'leadForm') {
		return (
			<LeadFormWrapper
				parallax={x.parallax}
				animation={x.animation}
				blockId={x.id}
			>
				<LeadFormPreloader
					data={x as SimplesBlocksType.Blocks.LeadForm}
					titleAs={titleAs}
				/>
			</LeadFormWrapper>
		)
	}
	if (type === 'lead-form-vertical')
		return (
			<LeadFormVerticalPreloader
				data={x as SimplesBlocksType.Blocks.LeadFormVertical}
				titleAs={titleAs}
			/>
		)
	if (type === 'lead-form-mod')
		return (
			<LeadFormModPreloader
				data={x as SimplesBlocksType.Blocks.LeadFormMod}
				titleAs={titleAs}
			/>
		)
	if (type === 'lead-form-half')
		return (
			<LeadFormPreloader
				data={x as SimplesBlocksType.Blocks.LeadFormHalf}
				titleAs={titleAs}
			/>
		)
	if (type === 'lead-form-horizontal-half')
		return (
			<LeadFormHorizontalHalfPreloader
				data={x as SimplesBlocksType.Blocks.LeadFormHorizontalHalf}
				titleAs={titleAs}
			/>
		)
	if (type === 'lead-form-contact')
		return (
			<LeadFormContactPreloader
				data={x as SimplesBlocksType.Blocks.LeadFormContact}
				titleAs={titleAs}
			/>
		)

	return null
	/*if (type === 'contact-info')
		return (
			<RenderContactInfo
				data={x as SimplesBlocksType.Blocks.ContactInfo}
				titleAs={titleAs}
			/>
		)
	if (type === 'contact-image')
		return (
			<RenderContactImage
				data={x as SimplesBlocksType.Blocks.ContactImage}
				titleAs={titleAs}
			/>
		)
	if (type === 'company-details')
		return (
			<RenderCompanyDetails
				data={x as SimplesBlocksType.Blocks.CompanyDetails}
				titleAs={titleAs}
			/>
		)
	if (type === 'cover')
		return (
			<RenderCover
				data={x as SimplesBlocksType.Blocks.Cover}
				titleAs={titleAs}
			/>
		)
	if (type === 'map-contact')
		return (
			<RenderMapContact
				data={x as SimplesBlocksType.Blocks.MapContact}
				titleAs={titleAs}
			/>
		)
	if (type === 'map-contact-mod')
		return (
			<RenderMapContactMod
				data={x as SimplesBlocksType.Blocks.MapContactMod}
				titleAs={titleAs}
			/>
		)
	if (type === 'banner') return <RenderBanner data={x} titleAs={titleAs} />
	if (type === 'banner-half')
		return <RenderBannerHalf data={x} titleAs={titleAs} />
	if (type === 'banner-timer')
		return <RenderBannerTimer data={x} titleAs={titleAs} />
	if (type === 'banner-full')
		return <RenderBannerFull data={x} titleAs={titleAs} />
	if (type === 'banner-text')
		return <RenderBannerText data={x} titleAs={titleAs} />
	if (type === 'banner-device')
		return (
			<RenderBannerDevice data={x} titleAs={titleAs} isUpperBlock={ind === 0} />
		)
	if (type === 'decor') return <RenderDecor data={x} titleAs={titleAs} />
	if (type === 'delimiter')
		return <RenderDelimiter data={x} titleAs={titleAs} />
	if (type === 'redirect') return <RenderRedirect data={x} />
	if (type === 'form') {
		if (x.form === 'rooms') return <RoomsForm data={x} titleAs={titleAs} />
		else return <ToursForm data={x} titleAs={titleAs} />
	}
	*/
	/* 	if (['card', 'marketing-slider', 'table'].includes(type as string)) {
		return (
			<StyledContainer
				paddingTop={x.padding_top}
				paddingBottom={x.padding_bottom}
			>
				<RenderView data={x} titleAs={titleAs} />
			</StyledContainer>
		)
	}
	return (
		<StyledContainer
			paddingTop={x.padding_top}
			paddingBottom={x.padding_bottom}
		>
			<LayoutWrapper size={x.size} offset={x.offset}>
				<RenderView data={x} titleAs={titleAs} />
			</LayoutWrapper>
		</StyledContainer>
	) */

	/*return (
		<Wrapper
			bgColor={convertColor(bgColor)}
			bgImage={bgImage}
			data-id={id}
			id={id}
		>
			<StyledContainer height={type ? blockHeights[type] : undefined}>
				<div>
					<div>
						<PreloadLine />
					</div>
					<div>
						<PreloadLine />
						<PreloadLine />
						<PreloadLine />
					</div>
				</div>
			</StyledContainer>
		</Wrapper>
	)*/
}

export const PreloaderNone = ({ id, type, bgColor, bgImage }: any) => (
	<Wrapper
		bgColor={convertColor(bgColor)}
		bgImage={bgImage}
		data-id={id}
		id={id}
	>
		<StyledContainer height={type ? blockHeights[type] : undefined}>
			<div>
				<div>
					<PreloadLine />
				</div>
				<div>
					<PreloadLine />
					<PreloadLine />
					<PreloadLine />
				</div>
			</div>
		</StyledContainer>
	</Wrapper>
)

const PreloadLine = () => (
	<ShimmerWrapper>
		<Shimmer />
	</ShimmerWrapper>
)

const Wrapper = styled.div<{ bgColor: ColorsSchemeNames; bgImage?: string }>`
	${opacityBackgroundCss}
`

const ShimmerWrapper = styled.div`
	overflow: hidden;
	opacity: 0.6;
	${themedBorderRadius}
`

const StyledContainer = styled(Container)<{ height?: string }>`
	${media.pure.greater(media.size.sm)} {
		padding: 50px 0;
		height: ${({ height }) => height || '300px'};
		& > div {
			display: flex;
			height: 100%;
			& > div {
				flex-basis: 50%;
				margin: 0 16px;
				&:last-child {
					padding-top: 16px;
					& > div {
						height: 24px;
						margin-bottom: 16px;
						&:nth-child(1) {
							height: 32px;
							width: 70%;
						}
						&:nth-child(2) {
							width: 100%;
						}
						&:nth-child(3) {
							width: 80%;
						}
					}
				}
				&:first-child {
					& > div {
						height: 100%;
					}
				}
			}
		}
	}
	${media.pure.less(media.size.sm)} {
		padding: 32px 16px;
		height: ${({ height }) => height || '360px'};
		& > div {
			& > :first-child {
				display: none;
			}
			& > :last-child {
				& > div {
					height: 32px;
					&:first-child {
						height: ${({ height }) => `calc(${height || '360px'} - 160px)`};
					}
					&:nth-child(2) {
						width: 60%;
					}
					&:last-child {
						width: 90%;
					}
					&:not(:last-child) {
						margin-bottom: 16px;
					}
				}
			}
		}
	}
`
